const localDefault = "http://127.0.0.1:8787/api";
// Production XML API host (unchanged until DNS cutover to digital-track-apps-api)
const productionDefault = "https://xml.digitaltrack.cloud/api";

// Prefer explicit env var; otherwise use local default in dev and Worker API in production builds.
const raw =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production" ? productionDefault : localDefault);

export const API_URL = raw.replace(/\/$/, "");
export const API_ORIGIN = API_URL.replace(/\/api\/?$/, "");
